import { type GetNotificationsResponseDto } from '@/common/types/notification';

import { api } from '../base';

type NotificationsQueryParams = {
  notReadOnly?: boolean;
  skip?: number;
  limit?: number;
};

const LIMIT = 30;

const notificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationsAll: builder.query<
      GetNotificationsResponseDto,
      NotificationsQueryParams
    >({
      query: (args) => {
        const params: Record<string, unknown> = {};
        params.skip = args.skip;
        params.take = typeof args.limit === 'undefined' ? LIMIT : args.limit;

        if (args?.notReadOnly !== undefined) {
          params['not-read-only'] = args.notReadOnly;
        }

        return {
          url: '/notification/all',
          method: 'GET',
          params,
        };
      },
    }),
    readAllNotifications: builder.mutation<void, void>({
      query: () => ({
        url: '/notification/read/all',
        method: 'POST',
      }),
    }),
    registerPushToken: builder.mutation<
      void,
      { token: string; platform: string }
    >({
      query: (body) => ({
        url: '/notification/push-token',
        method: 'POST',
        body,
      }),
    }),
    removePushToken: builder.mutation<void, { token: string }>({
      query: (body) => ({
        url: '/notification/push-token/remove',
        method: 'POST',
        body,
      }),
    }),
    getPushSettings: builder.query<
      { categories: string[]; disabled: string[] },
      void
    >({
      query: () => ({ url: '/notification/push-settings', method: 'GET' }),
    }),
    updatePushSettings: builder.mutation<
      { categories: string[]; disabled: string[] },
      { disabled: string[] }
    >({
      query: (body) => ({
        url: '/notification/push-settings',
        method: 'POST',
        body,
      }),
    }),
    readNotificationById: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/notification/read/${id}`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetNotificationsAllQuery,
  useGetNotificationsAllQuery,
  useReadAllNotificationsMutation,
  useReadNotificationByIdMutation,
  useRegisterPushTokenMutation,
  useRemovePushTokenMutation,
  useGetPushSettingsQuery,
  useUpdatePushSettingsMutation,
} = notificationsApi;
export { notificationsApi };
